import request from '../utils/request';

// 分页查询商品规格类型
export const listGoodsSpecTypes = (params) => {
  return request({
    url: '/goods-spec-type/page',
    method: 'post',
    data: params
  });
};

// 添加商品规格类型
export const addGoodsSpecType = (data) => {
  return request({
    url: '/goods-spec-type',
    method: 'post',
    data
  });
};

// 更新商品规格类型
export const updateGoodsSpecType = (data) => {
  return request({
    url: `/goods-spec-type/${data.id}`,
    method: 'put',
    data
  });
};

// 删除商品规格类型
export const deleteGoodsSpecType = (id) => {
  return request({
    url: `/goods-spec-type/${id}`,
    method: 'delete'
  });
};

// 获取商品规格类型详情
export const getGoodsSpecTypeDetail = (id) => {
  return request({
    url: `/goods-spec-type/${id}`,
    method: 'get'
  });
};
